import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

export const ConfirmDialog: React.FC<{ open: boolean; title: string; message: string; danger?: boolean; onConfirm: () => void; onCancel: () => void }> = ({ open, title, message, danger, onConfirm, onCancel }) => (
  <Modal open={open} onClose={onCancel} title={title}>
    <p className="text-sm text-text-primary mb-4">{message}</p>
    <div className="flex justify-end gap-2">
      <Button variant="secondary" onClick={onCancel}>Cancel</Button>
      <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm}>Confirm</Button>
    </div>
  </Modal>
);
